// put simple vue components / functions here that you want to reuse in many places like toasts, etc.

var TriStateSaveButton = {  
    name: 'TriStateSaveButton',
    inheritAttrs: false,
    props: {
        buttonText: {
            type: String,
            default: 'Save',
        },
        noChangesText: {  // text to show when all is saved
            type: String,
            default: 'All Saved',
        },
        buttonSize: {
            type: String,
            default: 'md',
        },
        variant: {
            type: String,
            default: 'success',
        },
        loading: {  // set to true when loading
            type: Boolean,
            default: false,
        },
        noChanges: {  // set to true when there are no changes to save, button disabled
            type: Boolean,
            default: false,
        },
        minWidthString: {
            type: String,
            default: '120px',
        }
    },
    data: function() {
        return {

        }
    },
    computed: {
        localState: function() {
            if (this.loading) return 'loading';
            if (this.noChanges) {
                return 'no-changes';
            } else {
                return 'save';
            }
        },
    },
    methods: {
        onClick: function() {
            this.$emit('click');
        },
    },
    // pulled this out of template - button text:  <span v-else-if="localState === 'no-changes'" key="noChanges">{{ noChangesText }}</span>
    template: `
        <b-button
            v-bind="$attrs"
            :variant="variant"
            :size="buttonSize"
            :disabled="localState !== 'save'"
            :style="{minWidth: minWidthString}"
            @click="onClick"
        >
            <transition name="fade-fast" mode="out-in">
                <b-spinner v-if="localState === 'loading'" small key="loading"></b-spinner>
                <span v-else-if="localState === 'save'" key="save">{{ buttonText }}</span>
                <span v-else-if="localState === 'no-changes'" key="noChanges">{{ noChangesText }}</span>
            </transition>
        </b-button>
    `
}


export {
    TriStateSaveButton,
}